import { render, staticRenderFns } from "./AulaSearchInput.vue?vue&type=template&id=22688f6c&scoped=true&"
import script from "./AulaSearchInput.vue?vue&type=script&lang=js&"
export * from "./AulaSearchInput.vue?vue&type=script&lang=js&"
import style0 from "./AulaSearchInput.vue?vue&type=style&index=0&id=22688f6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22688f6c",
  null
  
)

export default component.exports